<template>
  <el-dialog :title="$t('editMallMenu.edit')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="editMallMenuInfo" label-width="120px">
      <el-form-item :label="$t('editMallMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('editMallMenu.menuNameRequired') }]">
        <el-input v-model="editMallMenuInfo.hktName" :placeholder="$t('editMallMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('editMallMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="editMallMenuInfo.hktDesc" :placeholder="$t('editMallMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.label')" prop="label">
        <el-input v-model="editMallMenuInfo.label" :placeholder="$t('editMallMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('editMallMenu.sortRequired') }]">
        <el-input v-model="editMallMenuInfo.seq" :placeholder="$t('editMallMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('editMallMenu.showStatusRequired') }]">
        <el-select v-model="editMallMenuInfo.isShow" :placeholder="$t('editMallMenu.selectShowStatus')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveEditMallMenu">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMallMenu } from '@/api/admin/shopProductType/shopProductTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'EditMallMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      editMallMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '',
        isShow: '',
        typeCd: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true

      this.$refs.form && this.$refs.form.resetFields()
      this.editMallMenuInfo = { ...row }
      setTimeout(() => {
        this.$refs.uploadImage.setImages([row.hktIcon])
      }, 100)

    },
    handleUploadImage(photos) {
      this.editMallMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveEditMallMenu() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        await updateMallMenu(this.editMallMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>